module.exports = __webpack_public_path__ + "static/media/fast-backward.d729d2d8.svg";